import SmoothScroll from 'smoothscroll-for-websites/SmoothScroll';
import AOS from 'aos';

$(function () {
    new SmoothScroll({stepSize: 60});
});

window.addEventListener('load', () => {
  AOS.init({
      once: true,
      offset: 100,
      duration: 700,
      delay: 300
  });
});

$(document).ready(function () {
    // scroll to top *jquery for smoother scroll animation
    let $page = $('html, body');
    $('a.js-anchor-link').click(function H() {
      $page.animate({ scrollTop: $($.attr(this, 'href')).offset().top - 200 }, 2000);
      return false;
    });
});

/* Open burger menu */
const burgerMenu = document.querySelector('.js-open-burger'),
    header = document.querySelector('.js-header'),
    bodyEl = document.querySelector('body');
burgerMenu.addEventListener('click', (e) => {
    e.target.classList.toggle('open');
    header.classList.toggle('mob-open');
    bodyEl.classList.toggle('o-hidden');
});
/* /Open burger menu */

$(document).ready(function() {
  if ($(window).width() < 992) {
    $('.menu-item.menu-item-has-children > a[aria-current="page"]').css('pointer-events', 'none');
    $('.menu-item.menu-item-has-children').on('click', function() {
      $(this).toggleClass('active');
      $(this).find('.sub-menu').toggle(200);
    });
  }
});

window.addEventListener('scroll', function() {
  const header = document.querySelector('.js-header-alterable');
  const sections = document.querySelectorAll('section');
  const currentScroll = window.scrollY;

  if (header) {
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.clientHeight;
      const computedStyle = getComputedStyle(section);
      const backgroundColor = computedStyle.backgroundColor;
      const headerClassList = header.classList;

      if (currentScroll >= sectionTop && currentScroll <= sectionBottom) {
          if (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === 'transparent') {
            headerClassList.remove('light-header');
            headerClassList.remove('light-bg-header');
            headerClassList.add('dark-header');
            headerClassList.add('dark-bg-header');
          } else {
              headerClassList.remove('dark-header');
              headerClassList.remove('dark-bg-header');
              headerClassList.add('light-header');
              headerClassList.add('light-bg-header');
          }
      }
    });
  }
});

window.addEventListener('scroll', function() {
  if (window.scrollY > 1) {
    document.querySelector('header').classList.add('fixed');
  } else {
    document.querySelector('header').classList.remove('fixed');
    document.querySelector('header').classList.remove('light-bg-header');
    document.querySelector('header').classList.remove('dark-bg-header');
  }
});

/* eslint-disable */

if (document.querySelectorAll("section").length > 0) {
  
  let lastSection = document.querySelectorAll("section")[document.querySelectorAll("section").length - 1];

  let hasBackground = false;
  for (let i = 0; i < lastSection.querySelectorAll("*").length; i++) {
    if (lastSection.querySelectorAll("*")[i].style.backgroundColor === "#204e5f") {
      hasBackground = true;
      break;
    }
  }

  if (!hasBackground) {
    document.querySelector("footer").classList.add("no-border");
  }
}